// extracted by mini-css-extract-plugin
module.exports = {"list":"case-studies_list__6Xj_N","imageContainer":"case-studies_imageContainer__Leu7r","contentContainer":"case-studies_contentContainer__uEht_"};